#ifdef GL_ES
precision mediump float;
#endif

attribute float sizes;
attribute float randomValue;
attribute float angle;

varying float vRandomValue;
varying float vAngle;
varying vec3  vPos;

uniform vec3  cameraPos;
uniform vec3  diskCenter;
uniform vec3  diskNormal;

uniform float minRadius;
uniform float maxRadius;
uniform float maxCamDist;

uniform float minThick;
uniform float maxThick;

uniform float falloffExp;
uniform float falloffExpMajor;
uniform float fadePlane;
uniform float fadeThick;

uniform float u_probability;

void main() {
  vRandomValue = randomValue;
  vAngle       = angle;
  vPos         = position;

  vec3 worldPos = (modelMatrix * vec4(position, 1.0)).xyz;
  vec3 diff     = worldPos - diskCenter;

  float camDist = length(cameraPos - diskCenter);
  float t       = clamp(camDist / maxCamDist, 0.0, 1.0);

  float align = abs(dot(normalize(cameraPos - diskCenter),
                        normalize(diskNormal)));

  float dynamicMajorExp = mix(falloffExpMajor, falloffExp, align);

  float tExpMinor = pow(t, falloffExp);
  float tExpMajor = pow(t, dynamicMajorExp);

  float rMinor    = mix(minRadius, maxRadius, tExpMinor);
  float rMajor    = mix(minRadius, maxRadius, tExpMajor);
  float thickness = mix(minThick,   maxThick,   tExpMinor * 4.);

  vec3 diffNorm   = diskNormal * dot(diff, diskNormal);
  vec3 diffPlane  = diff - diffNorm;
  float distPlane = length(diffPlane);
  float height    = abs(dot(diff, diskNormal));

  float wPlane = smoothstep(rMinor, max(rMinor - fadePlane, 0.0), distPlane);

  vec3 proj     = normalize(cameraPos - diskCenter
                             - diskNormal * dot(cameraPos - diskCenter, diskNormal));
  vec3 camAxis  = normalize(proj);
  vec3 perpAxis = normalize(cross(diskNormal, camAxis));
  float dCamAxis  = dot(diffPlane, camAxis);
  float dPerpAxis = dot(diffPlane, perpAxis);

  float wEllipse = smoothstep(
    1.0, 0.0,
    (dCamAxis * dCamAxis) / (rMajor * rMajor) +
    (dPerpAxis * dPerpAxis) / (rMinor * rMinor)
  );

  float wThick = smoothstep(thickness, max(thickness - fadeThick, 0.0), height);

  float weight = wPlane * wEllipse * wThick;
  float apply = step(randomValue, u_probability);
  weight = mix(1.0, weight, apply);

  vec4 mv        = modelViewMatrix * vec4(position, 1.0);
  float baseSize = sizes * (300.0 / -mv.z);
  gl_PointSize   = baseSize * weight;
  gl_Position    = projectionMatrix * mv;
}
